import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.VehicleMake.List.IRequest;
type Response = Api.Core.VehicleMake.List.IResponse;
type Headers = Api.Core.VehicleMake.List.IHeaders;
const url = '/api/ProductManagement/VehicleMake';
export default async function vehicleMakeListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
